import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthProvider';

interface RequireAnonProps {
  children: React.ReactNode;
}

export const RequireAnon = ({ children }: RequireAnonProps) => {
  const { session, ready } = useAuth();

  if (!ready) {
    return null;
  }

  if (session) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
